import { render, staticRenderFns } from "./PushNotificationsList.vue?vue&type=template&id=0c199b82&"
import script from "./PushNotificationsList.vue?vue&type=script&lang=js&"
export * from "./PushNotificationsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports